// extracted by mini-css-extract-plugin
module.exports = {"text":"HeldOrderItems_text__Lp517"};